import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BugReportComponent } from "src/app/shared/components/bug-report/bug-report.component";
import { CreateBugReportComponent } from "src/app/shared/components/bug-report/create-bug-report/create-bug-report.component";
import { DetailsDiscutionSupportComponent } from "src/app/shared/components/bug-report/details-discution-support/details-discution-support.component";
import { ProfileComponent } from "src/app/shared/components/profile/profile.component";
import { MainComponent } from "./main/main.component";
import { PromoteComponent } from "./promote/promote.component";
import { RemunerationComponent } from "./remuneration/remuneration.component";
import { CampagnesLPComponent } from "../admin/location-partners/campagnes-lp/campagnes-lp.component";
import { AdStatisticsComponent } from "../advertiser/insights/ad-statistics/ad-statistics.component";

import { authGuard } from "src/app/shared/services/guard/auth-guard.service";
import { LocationPartnerStatsPremiumComponent } from "src/app/shared/components/location-partner-stats-premium/location-partner-stats-premium.component";
import { LocationStatisticsComponent } from "../admin/location-partners/location-statistics/location-statistics.component";
import { LocationPartnersComponent } from "../admin/location-partners/location-partners.component";

var routingAnimation = localStorage.getItem("animate");

const routes: Routes = [
  {
    path: "",
    redirectTo: "main",
    pathMatch: "full",
  },
  {
    path: "main",
    component: MainComponent,
    data: {
      animation: [routingAnimation],
      title: "Franchise Dashboard | Relead ",
      description: " ",
    },
  },
  {
    path: "promote",
    component: PromoteComponent,
    data: {
      animation: [routingAnimation],
      title: "Add new campaign | Relead ",
      description: " ",
    },
  },
  {
    path: "locations/repository",
    component: LocationPartnersComponent,
    data: {
      animation: [routingAnimation],
      title: "Locations list | Relead ",
    },
  },
  {
    path: "locations/campaigns",
    component: CampagnesLPComponent,
    data: {
      animation: [routingAnimation],
      title: "Locations list | Relead ",
    },
  },
  {
    path: "location-partners/campagnes/statistics/:campaignHasedID",
    component: AdStatisticsComponent,
    data: {
      animation: [routingAnimation],
    },
  },
  {
    path: "statistics",
    component: LocationPartnerStatsPremiumComponent,
    data: {
      animation: [routingAnimation],
      title: "Location partner statistics | Relead  ",
      description: " ",
    },
  },
  {
    path: "remuneration",
    component: RemunerationComponent,
    data: {
      animation: [routingAnimation],
      title: "Remuneration information | Relead ",
      description: " ",
    },
  },
  {
    path: "support",
    component: BugReportComponent,
    data: {
      animation: [routingAnimation],
      title: "Report a technical problem | Relead",
      description: " ",
    },
  },
  {
    path: "support/createBugReport",
    component: CreateBugReportComponent,
    data: {
      animation: [routingAnimation],
    },
  },
  {
    path: "profile",
    component: ProfileComponent,
    data: {
      animation: [routingAnimation],
      title: "Company information | Relead ",
    },
  },
  {
    path: "support/details",
    component: DetailsDiscutionSupportComponent,
    data: {
      queryParams: {
        ref: "ref",
      },
      animation: [routingAnimation],
      title: "See the details of the discussion | Relead  ",
    },
  },
  {
    path: "locations/repository/statistics",
    component: LocationStatisticsComponent,
    canActivate: [authGuard],
    data: {
      animation: [routingAnimation],
      title: "Location partner statistics | Relead ",
      queryParams: {
        title: "companyName",
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FranchiseRoutingModule {}
